import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LayerApi } from '../../../api/layer-api';
import { UserApi } from '../../../api/user-api';
import { environment } from '../../../environment';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var ShareLayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ShareLayerComponent, _super);
    function ShareLayerComponent(_vcr, layerService, userApi, layerApi, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.userApi = userApi;
        _this.layerApi = layerApi;
        _this.cdr = cdr;
        _this.userIdsLayerIsSharedWith = [];
        _this.loading = false;
        _this.userIds = [];
        _this.mapcoreUsers = [];
        _this.recipients = [];
        _this.alreadySharedNames = [];
        _this.outputSearchText = new Subject();
        _this.onclose = new EventEmitter();
        _this.inputSearchText = '';
        _this.sharingLayer = false;
        _this.successMessage = false;
        _this.failureMessage = false;
        _this.emailText = '';
        _this.registerEvent('onclose', _this.onclose);
        var milliseconds = 500;
        _this.outputSearchText
            .pipe(debounceTime(milliseconds))
            .subscribe(function (searchText) {
            if (searchText.length !== 0) {
                _this.getUserSearch(searchText);
            }
            else {
                _this.mapcoreUsers = [];
            }
        });
        return _this;
    }
    Object.defineProperty(ShareLayerComponent.prototype, "layerId", {
        get: function () { return this._layerId; },
        set: function (value) {
            this._layerId = value;
            if (this._layerId) {
                //make api call to get layer's currently linked users
                this.loading = true;
                this.getUserLayers();
            }
        },
        enumerable: true,
        configurable: true
    });
    ShareLayerComponent.prototype.getUserSearch = function (searchText) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, results, results_1, results_1_1, user;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.userApi.searchUsers(searchText)];
                    case 1:
                        results = _b.sent();
                        //don't show users that are already added as recipients && users that already have the map shared with them
                        this.mapcoreUsers = results.filter(function (user) { return !_this.userIds.includes(user.id) && !_this.userIdsLayerIsSharedWith.includes(user.id); });
                        this.alreadySharedNames = [];
                        try {
                            for (results_1 = tslib_1.__values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                                user = results_1_1.value;
                                if (this.userIdsLayerIsSharedWith.includes(user.id)) {
                                    this.alreadySharedNames.push(user.email);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareLayerComponent.prototype.selectUser = function (index) {
        this.recipients.push(this.mapcoreUsers[index]);
        this.userIds.push(this.mapcoreUsers[index].id);
        this.inputSearchText = '';
        this.mapcoreUsers = [];
    };
    ShareLayerComponent.prototype.shareLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var milliseconds, layers_1, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        milliseconds = 3000;
                        this.sharingLayer = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.layerApi.getLayers([this.layerId], 'name')];
                    case 2:
                        layers_1 = _a.sent();
                        return [4 /*yield*/, this.layerApi.shareLayer(this.userIds, this.layerId).then(function (result) {
                                if (result) {
                                    _this.sharingLayer = false;
                                    _this.successMessage = true;
                                    if (_this.includeEmail) {
                                        // TODO: send selected users an email. Messsage text and email addresses are already available.
                                        var emailAddresses = _this.recipients.map(function (x) { return x.email; });
                                        var emailSubject = environment.appName + ': New Shared Layer';
                                        var layerName = layers_1[0].name;
                                        _this.layerService.emailAboutSharedLayer(_this.layerId, layerName, emailAddresses, emailSubject, _this.emailText);
                                    }
                                    setTimeout(function () {
                                        _this.successMessage = false;
                                        _this.resetAndClose();
                                    }, milliseconds);
                                }
                                else {
                                    _this.sharingLayer = false;
                                    _this.failureMessage = true;
                                    setTimeout(function () {
                                        _this.failureMessage = false;
                                    }, milliseconds);
                                }
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.sharingLayer = false;
                        this.failureMessage = true;
                        setTimeout(function () {
                            _this.failureMessage = false;
                        }, milliseconds);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ShareLayerComponent.prototype.removeRecipient = function (index) {
        this.recipients.splice(index, 1);
        this.userIds.splice(index, 1);
    };
    ShareLayerComponent.prototype.resetAndClose = function () {
        this.mapcoreUsers = [];
        this.userIds = [];
        this.inputSearchText = '';
        this.recipients = [];
        this.emailText = '';
        this.alreadySharedNames = [];
        this.onclose.emit();
    };
    ShareLayerComponent.prototype.getUserLayers = function () {
        var _this = this;
        this.userIdsLayerIsSharedWith = [];
        this.layerApi.getUserLayers(this._layerId).then(function (data) {
            var e_2, _a;
            try {
                for (var _b = tslib_1.__values(data[0].userLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var userLayer = _c.value;
                    if (userLayer.accessLevel !== 'OWNER') {
                        _this.userIdsLayerIsSharedWith.push(userLayer.userId);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            _this.loading = false;
            _this.cdr.detectChanges();
        });
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Number])
    ], ShareLayerComponent.prototype, "layerId", null);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], ShareLayerComponent.prototype, "includeEmail", void 0);
    return ShareLayerComponent;
}(BaseComponent));
export { ShareLayerComponent };
